import Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';

import '../scss/style.scss';

import './fw/mixins.js';
import './fw/filters.js';
import './mixins.js';

import NotFound from './member/components/notFound.vue';
import Sitemap from './sitemap.vue';

import ResetPasswordRemindForm from './member/components/resetPasswordRemind.vue';
import ResetPasswordForm from './member/components/resetPassword.vue';
import LoginForm from './member/components/login.vue';
import SignupForm from './member/components/signup.vue';
import ProfileMenu from './member/components/profileMenu.vue';
import MemberSettings from './member/settings.vue';
import CompactMarunageForm from './member/components/compactMarunageForm.vue';
import DetailedMarunageForm from './member/components/detailedMarunageForm.vue';
import MarunageForm from './member/components/marunageForm.vue';
import CateringButton from './member/components/cateringButton.vue';
import ShowShopTel from './member/components/showShopTel.vue';
import DirectTelForm from './member/components/directTelForm.vue';
import ShopCheckbox from './member/components/shopCheckbox.vue';
import RelatedShops from './member/components/relatedShops.vue';
import HistoryShops from './member/components/historyShops.vue';
import freeTextSearch from './member/components/freeTextSearch.vue';
import SimpleSearchShopsForm from './member/components/simpleSearchShops.vue';
import AreaSearch from './member/components/areaSearch.vue';
import AreaShops from './member/components/areaShops.vue';
import YenOrPeopleShops from './member/components/yenOrPeopleShops.vue';
import HotEntry from './member/components/hotEntry.vue';
import MarunageButton from './member/components/marunageButton.vue';
import MarunageLink from './member/components/marunageLink.vue';
import SearchShopsForm from './member/components/searchShops.vue';
import FeatureShopSearchMenu from "./member/components/featureShopSearchMenu.vue";
import CheckedShopList from './member/components/checkedShopList.vue';
import Notifications from './member/notifications.vue';
import ChatsIndex from './member/chats/index.vue';
import ChatsDetail from './member/chats/detail.vue';
import SearchLocationLinks from "./member/components/searchLocationLinks.vue";
import PrefectureLinks from "./member/components/prefectureLinks.vue";
import AreaPageBreadcrumbs from "./member/components/areaPageBreadcrumbs.vue";
import SubAreaLinks from "./member/components/subAreaLinks.vue";
import FixedSelectionList from "./member/components/fixedSelectionList.vue";
import ShopMultipleLikeButton from "./member/components/shopMultipleLikeButton.vue";
import ShopMultipleLikeViewButton from "./member/components/shopMultipleLikeViewButton.vue";
import AmazonGiftDialog from "./member/components/amazonGiftDialog.vue";
import AreaFAQ from "./member/components/areaFAQ.vue";
import AreaSections from "./member/components/areaSections.vue";
import ShopDetailSchema from "./member/components/shopDetailSchema.vue";
import RatingStars from "./member/components/ratingStars.vue";
import ReviewForm from "./member/components/reviewForm.vue";
import ReviewThanks from "./member/components/reviewThanks.vue";
import DonutChart from "./member/components/donutChart.vue";
import SliderChart from "./member/components/sliderChart.vue";
import ViewsRatingStars from "./member/components/viewsRatingStars.vue";
import ShopReview from "./member/components/shopReview.vue";
import ShopReviews from "./member/components/shopReviews.vue";
import ShopReviewScore from "./member/components/shopReviewScore.vue";
import FrontPagination from "./member/components/frontPagination.vue";
import ShopRating from "./member/components/shopRating.vue";

import AdminCommonLoginForm from './components/adminCommonLogin.vue';

import AdminNotifications from './afadmin/notifications.vue';
import AdminShopNotifications from './afadmin/shopNotifications.vue';
import AdminShopActiveBanquets from './afadmin/shopActiveBanquets.vue';
import AdminShopsAuth from './afadmin/shops/auth.vue';
import AdminShopsIndex from './afadmin/shops/index.vue';
import AdminShopsNew from './afadmin/shops/new.vue';
import AdminShopsEdit from './afadmin/shops/edit.vue';
import AdminGroupsIndex from './afadmin/groups/index.vue';
import AdminCustomersIndex from './afadmin/customers/index.vue';
import AdminMarunagesTabs from './afadmin/marunagesTabs.vue';
import AdminMarunagesIndex from './afadmin/marunages/index.vue';
import AdminMarunagesChat from './afadmin/marunages/chat.vue';
import AdminDirectCalls from './afadmin/directCalls.vue';
import AdminDirectCallForms from './afadmin/directCallForms.vue';
import AdminReservationsIndex from './afadmin/reservations/index.vue';
import AdminCandidatesIndex from './afadmin/candidates/index.vue';
import AdminAnnouncements from './afadmin/announcements/index.vue';
import AdminReviewsIndex from './afadmin/reviews/index.vue';
import AdminMarunagesFollowChat from './afadmin/marunages/followChat.vue';

import ShopadminMessages from './shopadmin/messages.vue';
import ShopadminNotifications from './shopadmin/notifications.vue';
import ShopadminBanquetsTabs from './shopadmin/banquetsTabs.vue';
import ShopadminBanquets from './shopadmin/banquets/index.vue';
import ShopadminAdEntryBanner from './shopadmin/adEntryBanner.vue';
import ShopadminBanquetChat from './shopadmin/banquets/chat.vue';
import ShopadminCandidates from './shopadmin/candidates/index.vue';
import ShopadminCandidateDetail from './shopadmin/candidates/detail.vue';
import ShopadminDirectCalls from './shopadmin/directCalls.vue';
import ShopadminDirectCallDetail from './shopadmin/directCallDetail.vue';
import ShopadminReplyTemplates from './shopadmin/reply_templates/index.vue';
import ShopadminAcceptanceDates from './shopadmin/acceptance_dates/index.vue';
import ShopadminAnnouncements from './shopadmin/announcements.vue';
import ShopadminHomeTabs from './shopadmin/homeTabs.vue';
import ShopadminTitanLp from './shopadmin/titanLp.vue';
import ShopadminGlobalModals from './shopadmin/globalModals.vue';

import GroupadminShopsIndex from './groupadmin/shops/index.vue';
import GroupadminShopsAuth from './groupadmin/shops/auth.vue';

Vue.use(VueAxios, axios);

axios.defaults.headers.common = {
    'Accept': '*/*',
    'X-CSRFToken': $('input[name=csrfmiddlewaretoken]').val(),
    'X-Requested-With': 'XMLHttpRequest'
};

moment.locale('ja', {
    weekdays: ['日曜日','月曜日','火曜日','水曜日','木曜日','金曜日','土曜日'],
    weekdaysShort: ['日','月','火','水','木','金','土']
});

Vue.config.errorHandler = function(err, vm, info) {
    $.ajax({
        url: '/api/js_error',
        type: 'POST',
        data: {
            stack: err.stack
        },
        headers: {
            'X-CSRFToken': $('input[name=csrfmiddlewaretoken]').val(),
        }
    });
    console.log(err);
    alert('エラーが発生しました');
};

new Vue({
    el: '.root',
    data: {
        data: window.rootData || {},
        globalMessage: null,
        unreadNotifications: [],
        unreadAnnouncements: [],
        selectedShopCount: 0
    },
    components: {
        'not-found': NotFound,

        'sitemap': Sitemap,

        'reset-password-remind': ResetPasswordRemindForm,
        'reset-password': ResetPasswordForm,
        'login': LoginForm,
        'signup': SignupForm,
        'profile-menu': ProfileMenu,
        'member-settings': MemberSettings,
        'compact-marunage-form': CompactMarunageForm,
        'detailed-marunage-form': DetailedMarunageForm,
        'marunage-form': MarunageForm,
        'catering-button': CateringButton,
        'show-shop-tel': ShowShopTel,
        'direct-tel-form': DirectTelForm,
        'shop-checkbox': ShopCheckbox,
        'related-shops': RelatedShops,
        'history-shops': HistoryShops,
        'simple-search-shops-form': SimpleSearchShopsForm,
        'search-shops-form': SearchShopsForm,
        'feature-search-shop-menu': FeatureShopSearchMenu,
        'checked-shop-list': CheckedShopList,
        'free-text-search': freeTextSearch,
        'area-search': AreaSearch,
        'area-shops': AreaShops,
        'yen-or-people-shops': YenOrPeopleShops,
        'hot-entry': HotEntry,
        'marunage-button': MarunageButton,
        'marunage-link': MarunageLink,
        'notifications': Notifications,
        'chats-index': ChatsIndex,
        'chats-detail': ChatsDetail,
        'search-location-links': SearchLocationLinks,
        'prefecture-links': PrefectureLinks,
        'area-page-breadcrumbs': AreaPageBreadcrumbs,
        'sub-area-links': SubAreaLinks,
        'fixed-selection-list': FixedSelectionList,
        'shop-multiple-like-button': ShopMultipleLikeButton,
        'shop-multiple-like-view-button': ShopMultipleLikeViewButton,
        'amazon-gift-dialog': AmazonGiftDialog,
        'area-faq': AreaFAQ,
        'area-sections': AreaSections,
        'shop-detail-schema': ShopDetailSchema,
        'rating-stars': RatingStars,
        'review-form': ReviewForm,
        'review-thanks': ReviewThanks,
        'donut-chart': DonutChart,
        'slider-chart': SliderChart,
        'views-rating-stars': ViewsRatingStars,
        'shop-review': ShopReview,
        'shop-reviews': ShopReviews,
        'shop-review-score': ShopReviewScore,
        'front-pagination': FrontPagination,
        'shop-rating': ShopRating,

        'admin-common-login': AdminCommonLoginForm,

        'afadmin-notifications': AdminNotifications,
        'afadmin-shop-notifications': AdminShopNotifications,
        'afadmin-shop-active-banquets': AdminShopActiveBanquets,
        'afadmin-shops-auth': AdminShopsAuth,
        'afadmin-shops-index': AdminShopsIndex,
        'afadmin-shops-new': AdminShopsNew,
        'afadmin-shops-edit': AdminShopsEdit,
        'afadmin-groups-index': AdminGroupsIndex,
        'afadmin-customers-index': AdminCustomersIndex,
        'afadmin-marunages-tabs': AdminMarunagesTabs,
        'afadmin-marunages-index': AdminMarunagesIndex,
        'afadmin-marunages-chat': AdminMarunagesChat,
        'afadmin-direct-calls': AdminDirectCalls,
        'afadmin-direct-call-forms': AdminDirectCallForms,
        'afadmin-reservations-index': AdminReservationsIndex,
        'afadmin-candidates-index': AdminCandidatesIndex,
        'afadmin-announcements-index': AdminAnnouncements,
        'afadmin-reviews-index': AdminReviewsIndex,
        'afadmin-marunages-follow-chat': AdminMarunagesFollowChat,

        'shopadmin-messages': ShopadminMessages,
        'shopadmin-notifications': ShopadminNotifications,
        'shopadmin-banquets-tabs': ShopadminBanquetsTabs,
        'shopadmin-banquets': ShopadminBanquets,
        'shopadmin-ad-entry-banner': ShopadminAdEntryBanner,
        'shopadmin-banquet-chat': ShopadminBanquetChat,
        'shopadmin-candidates': ShopadminCandidates,
        'shopadmin-candidate-detail': ShopadminCandidateDetail,
        'shopadmin-direct-calls': ShopadminDirectCalls,
        'shopadmin-direct-call-detail': ShopadminDirectCallDetail,
        'shopadmin-reply-templates': ShopadminReplyTemplates,
        'shopadmin-acceptance-dates': ShopadminAcceptanceDates,
        'shopadmin-announcements': ShopadminAnnouncements,
        'shopadmin-home-tabs': ShopadminHomeTabs,
        tlp: ShopadminTitanLp,
        'shopadmin-global-modals': ShopadminGlobalModals,

        'groupadmin-shops-index': GroupadminShopsIndex,
        'groupadmin-shops-auth': GroupadminShopsAuth,
    },
    created: function() {
        $(window).on('error', function(evt) {
            /* eslint-disable */
            console.log(evt);
            /* eslint-enable */
            // TODO: POST stack trace to google spread sheet
        });
        this.selectedShopCount = this.selectedShops().length;
    },
    mounted: function() {
        this.pollUnreadNotifications();
        this.pollUnreadAnnouncements();
    },
    methods: {
        pollUnreadNotifications: function() {
            window.data.uid && this.setInterval(function() {
                this.createForm({
                    read: false
                }).get(this.roleContext + '/api/notifications', function(response) {
                    this.unreadNotifications = response.data;
                }, function(err) {
                    if (err.response.status === 403) {
                        location.reload();
                    }
                });
            }, 10 * 1000);
        },
        pollUnreadAnnouncements: function() {
            if (this.roleContext !== '/shopadmin') {
                return;
            }
            window.data.uid && this.setInterval(function() {
                this.createForm({
                    announcement_read: false
                }).get(this.roleContext + '/api/announcements', function(response) {
                    this.unreadAnnouncements = response.data;
                }, function(err) {
                    if (err.response.status === 403) {
                        location.reload();
                    }
                });
            }, 10 * 1000);
        },
        logout: function() {
            this.createForm().post(this.roleContext + '/api/logout', function() {
                window.location.href = this.roleContext + '/';
            });
        }
    },
    computed: {
        roleContext: function() {
            var role = window.data.role;
            var context = '';
            if (role) {
                context = '/' + role;
            }
            return context;
        }
    }
});
